import { AfterViewChecked, Directive, Input, OnChanges, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { JpatsPolicyPermissionsService } from './services/jpats-policy-permissions.service';

@Directive({
  selector: '[hasPermission]'
})
export class HasPermissionDirective implements OnInit, OnChanges {
  @Input() set hasPermission(permissions: string[]) {
    this.permissions = permissions;
  }
  @Input() set hasPermissionOperation(op) {
    this.operation = op;
  }
  @Input() set hasPermissionIf(showIf) {
    this.showIf = !!showIf;
  }
  @Input() set hasPermissionOrganization(organization) {
    this.organization = organization;
  }

  private permissions: string[] = [];
  private operation: string = 'OR';
  private organization: number;
  private showIf = true;

  constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef, private policyPermissionsService: JpatsPolicyPermissionsService) {
  }
  async ngOnInit() {
    await this.updateView();
  }
  async ngOnChanges() {
    await this.updateView();
  }
  private async updateView() {
    let hasPermission = await this.checkPermission();
    if (hasPermission && this.showIf) {
      this.viewContainer.clear();
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
  private async checkPermission() {
    if (this.permissions && this.permissions.length === 0) {
      return true;
    }
    if (this.operation === 'OR') {
      return this.policyPermissionsService.hasAnyPermissions(this.permissions);
    }
    if (this.operation === 'AND') {
      return this.policyPermissionsService.hasAllPermissions(this.permissions);
    }
  }

}
